app.service('productAvailabilityShopTabs', function(
	productAvailabilityShopMap
) {
	let $self, $tabs;

	let state = {
		mode: 'LIST'
	};

	function setActiveTab() {
		$tabs
			.filter(`[data-mode=${state.mode}]`)
			.addClass('is-active')
			.siblings()
			.removeClass('is-active');
	}

	function hideList() {
		$self.removeClass('is-visible');
	}

	function showInfoMessage() {
		if (state.mode === 'MAP') {
			changeTab('LIST');
		}

		$tabs.filter(`[data-mode=MAP]`).addClass('is-disabled');
	}

	function showList() {
		$self.addClass('is-visible');
		$tabs.removeClass('is-disabled');
	}

	function changeTab(mode) {
		$self.removeClass(`show-${state.mode}`).addClass(`show-${mode}`);

		state.mode = mode;

		setActiveTab();
		productAvailabilityShopMap.update();
	}

	function handleClickTab(e) {
		changeTab(e.target.dataset.mode);
	}

	function setEvents() {
		$self.on('click', '.js-tab-list, .js-tab-map', handleClickTab);
	}

	function init() {
		$self = $('.shop-list-control');
		$tabs = $self.find('.shop-list-tab');

		setEvents();
	}

	return {
		init,
		showList,
		hideList,
		changeTab,
		showInfoMessage
	};
});
